import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Italic icon — italic "I" letter form.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const ItalicIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M14 3.33203C14.3682 3.33203 14.667 3.63083 14.667 3.99902C14.667 4.36721 14.3682 4.66602 14 4.66602H11.8682L9.49805 15.332H11.333C11.7012 15.332 12 15.6308 12 15.999C12 16.3672 11.7012 16.666 11.333 16.666H6C5.63181 16.666 5.33301 16.3672 5.33301 15.999C5.33301 15.6308 5.63181 15.332 6 15.332H8.13184L10.502 4.66602H8.66699C8.2988 4.66602 8 4.36721 8 3.99902C8 3.63083 8.2988 3.33203 8.66699 3.33203H14Z"
      fill="currentColor"
    />
  </svg>
);

export default ItalicIcon;
